module.exports = __webpack_public_path__ + "media/images/landing/save_time_bubles-1d03e10c6f2d0253b681d33854a4338b.svg";